import { getAssociatedTokenAddressSync } from '@solana/spl-token';
import { PublicKey } from '@solana/web3.js';
import { useQuery } from '@tanstack/react-query';

import { connection } from '@/constants/solana';
import { useAuthenticatedWallet } from '@/hooks/ui/use-authenticated-wallet';
import { compareData } from '@/utils/fetch.utils';

export const useFetchTokenBalance = (token: PublicKey, userId?: string) => {
  const { publicKey } = useAuthenticatedWallet();
  const address = userId || publicKey?.toBase58();
  return useQuery({
    queryKey: ['token-balance', token.toString(), address],
    refetchInterval: 30 * 1000,
    enabled: Boolean(address),
    structuralSharing: compareData,
    queryFn: async () => {
      try {
        if (!token || !address) return { amount: 0, uiAmount: 0 };

        const ata = getAssociatedTokenAddressSync(
          token,
          new PublicKey(address),
        );

        const balance = await connection.getTokenAccountBalance(ata);
        return balance.value;
      } catch (error) {
        console.log(error);
        return { amount: 0, uiAmount: 0 };
      }
    },
  });
};
